/* eslint-disable jira/import-whitelist */
import { isFilterId } from '@atlassian/jira-issue-navigator-actions-common/src/utils/filters/index.tsx';
import { toProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import {
	getDefaultJql as getDefaultJqlPin,
	mapFilterToJql as mapFilterToJqlPin,
} from '@atlassian/jira-spa-apps-project-issue-navigator-utils/src/index.tsx';
import type { RouterDataContext, RouterContext } from '@atlassian/react-resource-router';
import { defaultOrderFields, sortDirections } from '../../constants.tsx';

export const getDefaultJqlGin = () =>
	`ORDER BY ${defaultOrderFields.created} ${sortDirections.DESC}`;

export const getParams = ({ match: { params }, query }: RouterDataContext | RouterContext) => {
	const { projectKey, issueKey } = params;

	const { filter, jql } = query;

	// Default JQL when no relevant query parameter is set
	const defaultJql =
		projectKey !== null && projectKey !== undefined
			? getDefaultJqlPin(toProjectKey(projectKey))
			: getDefaultJqlGin();

	return { page: 1, jql, issueKey, projectKey, filter, defaultJql };
};

export const getJqlOrFilterId = (
	defaultJql: string,
	jqlParam?: string,
	filter?: string,
	projectKey?: string | null,
): { jql: string } | { filterId: string } => {
	// If JQL param has been defined (even if it's empty) we should use it
	if (typeof jqlParam === 'string') {
		return { jql: jqlParam };
	}
	// If filter is non-empty then use the filter parameter
	if (typeof filter === 'string' && filter !== '') {
		if (isFilterId(filter)) {
			return { filterId: filter };
		}

		const filterJql =
			projectKey !== null && projectKey !== undefined
				? mapFilterToJqlPin(projectKey, filter)
				: undefined;

		if (filterJql !== undefined) {
			return { jql: filterJql };
		}
	}

	// Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
	return { jql: defaultJql };
};
